import { action } from 'satcheljs';

export let openPremiumUpsell = action('PREMIUM_UPSELL');
